<template>
    <div class="container mb-4">
        <div class="row">
            <div class="col-12 col-md-4">
                <emblem>Profiel</emblem>
                <member-info
                    :member="currentMember"
                    class="h-auto"
                ></member-info>
                <emblem v-if="!IsGuestMember">Instellingen</emblem>
                <profile-settings
                    v-if="!IsGuestMember"
                    v-model="activeTab"
                    :settings="settings"
                ></profile-settings>
            </div>

            <div v-if="activeTab === 'myData'" class="col-12 col-md-8">
                <emblem>{{ settings.myData }}</emblem>
                <profile-data :member="currentMember"></profile-data>
                <emblem v-if="IsGuestMember">{{ settings.myGroups }}</emblem>
                <my-updates
                    v-if="IsGuestMember"
                    :load-data="IsGuestMember"
                ></my-updates>
            </div>

            <div
                v-if="!IsGuestMember && activeTab === 'notifications'"
                class="col-12 col-md-8"
            >
                <emblem>{{ settings.notifications }}</emblem>
                <profile-notifications
                    :title="legislationsTitle"
                ></profile-notifications>
            </div>

            <div
                v-if="!IsGuestMember && activeTab === 'password'"
                class="col-12 col-md-8"
            >
                <emblem>{{ settings.password }}</emblem>
                <slot name="password"></slot>
            </div>

            <div v-if="activeTab === 'groups'" class="col-12 col-md-8">
                <emblem>{{ settings.groups }}</emblem>
                <slot name="groups"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import emblem from '@/components/emblem';
import memberInfo from '@/components/members/member-info';
import profileSettings from '@/components/profile/profile-settings';
import profileData from '@/components/profile/profile-data';
import profileNotifications from '@/components/profile/profile-notifications';
import myUpdates from '@/components/profile/my-updates';

export default {
    components: {
        memberInfo,
        profileSettings,
        profileData,
        profileNotifications,
        myUpdates,
        emblem
    },

    props: {
        settings: {
            type: Object,
            default() {
                return {};
            }
        },
        legislationsTitle: {
            type: String,
            default() {
                return 'Legislation Dashboard';
            }
        }
    },

    data() {
        return {
            currentMember: {},
            activeTab: 'myData',
            IsGuestMember: true
        };
    },

    watch: {
        activeTab(val) {
            window.location.hash = val;
        }
    },

    created() {
        this.getCurrentMemberInfo();

        if (window.location.hash.length) {
            this.activeTab = window.location.hash.split('#')[1];
        }
    },

    methods: {
        getCurrentMemberInfo() {
            const url = '/api/v1/domainapi/currentmember';
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.currentMember = response.data.profile;
                    this.IsGuestMember = response.data.memberType !== 'NVB';
                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>
